import { v4 as uuidv4 } from 'uuid';
import { Dialog } from "construct-ui";
import paginationComponent from "../../../components/pagination/pagination.component";
import scheduleModel from "../../../models/schedule/jpo-schedule.model";
import ViewBase from "../../view-base.view";

export default function UnplannedStoreDialog() {
    ViewBase.call(this);

    let FilterDate = '';
    let BU = '';
    let SupervisorIds = '';
    let SupervisorId = '';
    let SupervisorRoles = '';
    let tableData = [];

    const DEFAULT_PAGINATION = {
        pageSize: 10,
        pageIndex: 1,
        totalCount: 0,
    };

    let pagination = structuredClone(DEFAULT_PAGINATION);
    const STYLE_MIN_HEIGHT = '500px';

    const getUnplannedStore = () => {
        this.showLoading();
        return scheduleModel.getSchedulePlanAndActualUnplannedStore(
            (result) => {
                //tableData = result.data;
                pagination.pageIndex = result.pageIndex;
                pagination.pageSize = result.pageSize;
                pagination.totalCount = result.total;

                //Check and Call JPO API to get error message
                
                getJPOErrorMsg(result.data);

                this.hideLoading();
            },
            (error) => {
                this.handleError(error);
                this.hideLoading();
            },
            {
                FilterDate: FilterDate,
                BU: BU,
                SupervisorId: SupervisorId,
                SupervisorIds: SupervisorIds,
                SupervisorRoles: SupervisorRoles,
                pageSize: pagination.pageSize,
                pageIndex: pagination.pageIndex,
            }
        )
    }

    let getJPOErrorMsg = (data) => {
        tableData = data;

        if (data.length === 0) return;

        const requests = data
            .filter(d => !d.reason)
            .map(d => ({ userId: d.userId, storeId: d.storeId }));

        if (requests.length === 0) return;
        
        
        scheduleModel.getJPOErrorMessage(
            (result) => {
                
                if (result) {
                    data.forEach(d => {
                        const error = result.find(r => r.storeCode === d.storeId && r.userId === d.userId);
                        
                        if (error) {
                            d.reason = error.message;
                        }
                    });
                }
            },
            (error) => {
                this.handleError(error);
            },
            {
                requestList: requests
            }
        );

        tableData = data;
    }

    const onPageChanged = (page) => {
        pagination.pageIndex = page;
        getUnplannedStore();
    }
    const onPageSizeChanged = (page, size) => {
        pagination.pageIndex = page;
        pagination.pageSize = size;
        getUnplannedStore();
    }

    let _downloadExcel = () => {
        this.showLoading();
        const inputDataModel = {
            filterDate: FilterDate,
            bu: BU,
            SupervisorId: SupervisorId,
            SupervisorIds: SupervisorIds,
            SupervisorRoles: SupervisorRoles
        };

        scheduleModel.jpoUnassignedStoresDownloadExcel(inputDataModel)
                    .catch((error) => {
                        this.handleError(error);
                    })
                    .finally(() => {
                        this.hideLoading();
                    });
    }

    return {
        oninit: ({ attrs: { inputFilterDate, inputBU, inputSupervisorId, inputSupervisorIds, inputSupervisorRoles } }) => {
            FilterDate = inputFilterDate;
            BU = inputBU;
            SupervisorId = inputSupervisorId;
            SupervisorIds = inputSupervisorIds;
            SupervisorRoles = inputSupervisorRoles;
            getUnplannedStore();
        },
        view: ({ attrs: { onClose } }) => [
            m(Dialog, {
                title: this.getText("LT00008119", "Unassigned Stores"),
                class: 'cui-dialog-l',
                isOpen: true,
                onClose: onClose,
                closeOnEscapeKey: false,
                closeOnOutsideClick: false,
                content:

                    m('.card',
                        m('.card-body',
                                m('.d-flex.justify-content-end.mb-2',
                                    m('a.btn.btn-primary', { onclick: _downloadExcel },
                                        m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download"),
                                    )
                                )
                            ,
                            m('.row.g-2 ',
                                m('.col-20.p-0',
                                    m('.table-responsive', { style: { 'min-height': STYLE_MIN_HEIGHT }, },
                                        m('table.table.table-hover',
                                            m('thead',
                                                m('tr.align-middle',
                                                    m("th", { "scope": "col" }, this.getText("LT00008154", "Supervisor ID")),
                                                    m("th", { "scope": "col" }, this.getText("LT00000169", "Store")),                                                    
                                                    m("th", { "scope": "col" }, this.getText("LT00008118", "Unassigned Reason")),
                                                ),
                                            ),
                                            m('tbody',
                                                tableData.length > 0 &&
                                                tableData.map((data, index) =>
                                                    m('tr.align-middle',
                                                        m('td', m('span.cursor-text', data.userId)),
                                                        m('td', m('span.cursor-text', data.storeId)),                                                        
                                                        m('td', m('span.cursor-text', data.reason)),
                                                    )
                                                )
                                            )
                                        ),
                                    ),
                                    tableData.length > 0 &&
                                    m(".px-3",
                                        m(paginationComponent, {
                                            currentPage: pagination.pageIndex,
                                            pageSize: pagination.pageSize,
                                            totalItems: pagination.totalCount,
                                            onPageChanged: onPageChanged,
                                            onPageSizeChanged: onPageSizeChanged
                                        })
                                    )
                                )
                            )
                        ),
                        this.getBaseViews()
                    ),
            })
        ]
    }
}